try{
    const dropdowns = document.getElementsByClassName("dropdown-item")
    for(let dropdown of dropdowns){
        dropdown.addEventListener('click',function(e) {
            if(dropdown.nextElementSibling.classList.contains('active')){
                dropdown.nextElementSibling.classList.remove('active');
                dropdown.classList.remove("dropdown-active")
                return
            }
            for(let dropdown_close of dropdowns){
                if(dropdown_close.nextElementSibling.classList.contains('active')){
                    dropdown_close.nextElementSibling.classList.remove('active');
                    dropdown_close.classList.remove("dropdown-active")
                }
            }
            dropdown.classList.add("dropdown-active")
            dropdown.nextElementSibling.classList.add('active');
        })
    }
    
    const dropdowns_child = document.getElementsByClassName("dropdown-item-child")
    
    for(let dropdown of dropdowns_child){
        dropdown.addEventListener('click',function(e) {
            if(dropdown.classList.contains("dropdown-active")){
                dropdown.classList.remove("dropdown-active")
                dropdown.nextElementSibling.classList.remove('active');
                return
            }
            dropdown.classList.add("dropdown-active")
            dropdown.nextElementSibling.classList.add('active');
        })
    }
    
    const view_more = document.getElementsByClassName("view-more-content")
    
    for(let dropdown of view_more){
        dropdown.addEventListener('click',function(e) {        
            if(dropdown.classList.contains("active")){
                dropdown.classList.remove("active")
                return
            }
            dropdown.classList.add("active")
        })
    }
    const buttons = document.querySelectorAll(".back-to-top");

    if (buttons.length > 0) {
    buttons.forEach((btn) => {
        btn.addEventListener("click", function (e) {
        e.preventDefault();

        const el = btn.closest(".main-menu__content");

        if (el) {
            el.scrollTo({ top: 0, behavior: "smooth" });
        }
        });
    });
    }
    const buttons_footer = document.querySelectorAll(".back-to-top-footer");
    if(buttons_footer.length > 0){
        buttons_footer.forEach((btn) => {
            btn.addEventListener("click", function (e) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
        });
    }
}catch(e){

}